import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const PageLoadingBar: React.FC = () => {
    const location = useLocation();
    const [visible, setVisible] = useState(false);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        // Mỗi khi đổi link, hiện thanh bar và chạy animation
        setVisible(true);
        setProgress(30);

        const timer1 = setTimeout(() => setProgress(70), 200);
        const timer2 = setTimeout(() => {
            setProgress(100);
            setTimeout(() => {
                setVisible(false);
                setProgress(0);
            }, 300);
        }, 500);

        return () => {
            clearTimeout(timer1);
            clearTimeout(timer2);
        };
    }, [location.pathname, location.key]);

    if (!visible) return null;

    return (
        <div 
            className="fixed top-0 left-0 h-1 bg-primary z-[9999] transition-all duration-300 ease-out shadow-[0_0_10px_rgba(40,51,126,0.5)]"
            style={{ width: `${progress}%`, opacity: progress === 100 ? 0 : 1 }}
        />
    );
};

export default PageLoadingBar;
